import type { RouteRecordNameGeneric, RouteRecordRaw } from 'vue-router'

import { RelationType } from '@/constants/relations'

import { routeCustomerDetail, routeCustomerRoot } from './customer'
import { routeInvestorDetail, routeInvestorRoot } from './investor'
import { routeOtherDetail, routeOtherRoot } from './other'
import { routePartnerDetail, routePartnerRoot } from './partner'
import { routeSalesPartnerDetail, routeSalesPartnerRoot } from './salesPartner'
import { routeSupplierDetail, routeSupplierRoot } from './supplier'

const getOrganizationDetailRoute = (
  relationType: RelationType | string | undefined,
): RouteRecordRaw => {
  switch (relationType) {
    case RelationType.customers:
    case 'customer':
      return routeCustomerDetail
    case RelationType.suppliers:
    case 'supplier':
      return routeSupplierDetail
    case RelationType.partners:
    case 'tw-partner':
      return routePartnerDetail
    case RelationType.salesPartners:
    case 'sales-partner':
      return routeSalesPartnerDetail
    case RelationType.investors:
    case 'bank':
      return routeInvestorDetail
    case RelationType.other:
    case 'tw-other':
      return routeOtherDetail
    case undefined:
      return routeCustomerDetail
    default: {
      return routeCustomerDetail
    }
  }
}

// Get the RelationType based on the organization detail route
const getOrganizationRelationType = (routeName: RouteRecordNameGeneric): RelationType => {
  // if routeName is child of routeCustomerRoot
  if (routeCustomerRoot.children?.some((child) => child.name === routeName)) {
    return RelationType.customers
  } else if (routeSupplierRoot.children?.some((child) => child.name === routeName)) {
    return RelationType.suppliers
  } else if (routePartnerRoot.children?.some((child) => child.name === routeName)) {
    return RelationType.partners
  } else if (routeSalesPartnerRoot.children?.some((child) => child.name === routeName)) {
    return RelationType.salesPartners
  } else if (routeInvestorRoot.children?.some((child) => child.name === routeName)) {
    return RelationType.investors
  } else if (routeOtherRoot.children?.some((child) => child.name === routeName)) {
    return RelationType.other
  }

  return RelationType.customers
}

export { getOrganizationDetailRoute, getOrganizationRelationType }
